import {Page} from "./styled";
import {useEffect} from "react";
import {User} from "react-feather";
import {Header, Line} from "components";
import {useParams} from "react-router-dom";
import {Credit, Info, Products} from "./lib";
import {resetClientSlice} from "global/slices";
import {useAppDispatch, useAppSelector} from "hooks";
import {initialState} from "global/slices/clients/initial-state";
import {getById, getClientProducts} from "global/slices/clients/thunks";

interface ClientProps {}

export const Client: React.FC<ClientProps> = () => {
  const {clientId} = useParams();
  const dispatch = useAppDispatch();
  const {client} = useAppSelector("clients");
  useEffect(() => {
    if (clientId) {
      dispatch(getById(clientId));
      dispatch(
        getClientProducts({
          ...initialState["clientProductsPagination"],
          clientId,
        })
      );
    }
    return () => {
      dispatch(resetClientSlice());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId]);

  return (
    <Page>
      <Header
        goBack
        icon={User}
        children={`Cliente ${client["nombre"]} ${client["apellido"]}`}
      />
      <Info />
      <Credit />
      <Line />
      <Products />
    </Page>
  );
};
